import { render, staticRenderFns } from "./Quickpick.vue?vue&type=template&id=71041ab4&scoped=true"
import script from "./Quickpick.vue?vue&type=script&lang=js"
export * from "./Quickpick.vue?vue&type=script&lang=js"
import style0 from "./Quickpick.vue?vue&type=style&index=0&id=71041ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71041ab4",
  null
  
)

export default component.exports